import { useState, useEffect } from 'react';
import { getBinList, deleteBin } from 'helpers/backend_helper';
import { Common } from 'helpers/common';
import filterDataBySearch from 'Common/filterDataBySearch';

export const useBinList = () => {
    const [allBin, setAllBin] = useState<any[]>([]);
    const [binList, setBinList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadBins(false);
    }, []);

    const loadBins = async (reload: boolean) => {
        try {
            if (binList.length === 0 || reload) {
                const response = await getBinList();
                if (response) {
                    setBinList(response.data as never[]);
                    setAllBin(response.data as never[]);
                }
            }
        } catch (error) {
            console.error('Error loading bins:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (binId: number) => {
        try {
            await deleteBin(binId);
            setBinList((prevList) => prevList.filter((bin: any) => bin.id !== binId));
            uiHelper.showSuccessMessage("Bin has been deleted successfully.");
            return true;
        } catch (error) {
            console.error('Error deleting bin:', error);
            return false;
        }
    };

    const updateBinList = (result: any, isEdit: boolean, binData: any) => {
        if (isEdit) {
            setBinList((prevList) =>
                prevList.map((bin: any) =>
                    bin.id === binData.id ? { ...result } : { ...bin }
                )
            );
        } else {
            setBinList((prevList) => [{ ...result }, ...prevList]);
        }
    };

    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['name', 'rack_id'];
        filterDataBySearch(allBin, search, keysToSearch, setBinList);
    };

    return {
        binList,
        isLoading,
        handleDelete,
        updateBinList,
        filterSearchData
    };
};